import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class NonInvoicedJobsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            isLoading:false,
            getInvoicedReportUrl:'/api/v1/portal/portal-admin/non-invoiced-jobs-report',
            InvoicedJobsReportData:[],
            downloadReportName:'Non Invoiced Jobs Report',
            selectedCustomers:[],
            customers:[],
            url: "/api/v1/portal/customers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    componentDidMount() {
        let options = [];   
        return fetch(this.state.url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
              response.map((customer)=>{
                options.push({
                    label : customer.company.short_name+'-'+customer.name,
                    value : customer.id
                });
            });
            this.setState({
              customers: options,
              isLoading: false
            });
          });
        });
      }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleCustomerSelection(selectedCustomers) {
        this.setState({selectedCustomers});
    }
    handleInvoicedJobsReportGeneration(e) {
        this.setState({isLoading: true});
        let url = this.state.getInvoicedReportUrl;
        return fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify({
            customer_ids: this.state.selectedCustomers,
            start_date:moment(this.state.startDate).format("YYYY-MM-DD"),
            end_date:moment(this.state.endDate).format("YYYY-MM-DD")
          }),
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
            this.setState({
                InvoicedJobsReportData: response,
                isLoading: false
            })
          });
        });
    }
    download(filename, text) {
        filename = filename+' From '+moment(this.state.startDate).format("YYYY-MM-DD")+' To '+moment(this.state.endDate).format("YYYY-MM-DD")+'.xlsx';
        let url = "/api/v1/portal/finance/non-invoiced-job-report";
            return fetch(url,{
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                    "Authorization": 'Bearer ' + window.api_token,
                    "Accept": 'application/json',
                },
                body: JSON.stringify({
                    customer_ids: this.state.selectedCustomers,
                    start_date:moment(this.state.startDate).format("YYYY-MM-DD"),
                    end_date:moment(this.state.endDate).format("YYYY-MM-DD")
                }),
            }
            ).then(response => response.blob())
                .then(blob => {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a); 
                    a.click();    
                    a.remove(); 
                }).catch(err=>{
                    alert('sorry something went wrong.');
                });
      }
    render() {
        let invoicedJobs = [];
        const {selectedCustomers} = this.state;
        let downloadableCsvDataInvoiced = "Job Ref,Reg/VIN,Customer,DRIVER,DRIVER PRICE,ABORTED JOB, CANCELLED JOB\n";
        // DATE,From Address,To Address,MILES,Job price,FUEL,FUEL INCL,EXPENSES APP,ADMIN FEE,Invoice Number\n";
        if(this.state.InvoicedJobsReportData.length > 0){
            this.state.InvoicedJobsReportData.map((currentJob, index) => {
                let joburl = "/jobs/view/"+currentJob.id;
                let expenses_approval_price = parseFloat(currentJob.expenses_approval_price).toFixed(2);
                let expenses_approval_fuel_total = parseFloat(currentJob.expenses_approval_fuel_total).toFixed(2);
                let totalPrice = parseFloat(currentJob.job_price) + parseFloat(expenses_approval_price);
                totalPrice = parseFloat(totalPrice).toFixed(2);
                invoicedJobs.push(
                    <tr key={index}>
                        <td className="job-ref-font16"><a href={joburl}>{currentJob.id}</a></td>
                        <td>{currentJob.vehicle.registration_number != null ? currentJob.vehicle.registration_number : currentJob.vehicle.vin_number}</td>        
                        <td>{currentJob.customer.name}</td>
                        <td>{(currentJob.driver) ? currentJob.driver.user.full_name : ''}</td>
                        <td>&pound;{currentJob.driver_price}</td>
                        <td>{currentJob.status != 'aborted' ? 'No' : 'YES'}</td>
                    </tr>
            );
            var pickupAddress = ((currentJob.pickup_address)&&(currentJob.pickup_address.address_line_1))?currentJob.pickup_address.address_line_1:'';
            var dropAddress = ((currentJob.dropoff_address)&&(currentJob.dropoff_address.address_line_1))?currentJob.dropoff_address.address_line_1:'';

            downloadableCsvDataInvoiced = downloadableCsvDataInvoiced +
                                            currentJob.id+','+
                                            currentJob.vehicle.registration_number+','+
                                            currentJob.customer.name+','+
                                            ((currentJob.driver) ? currentJob.driver.user.full_name : '')+','+
                                            currentJob.driver_price+','+
                                            ((currentJob.status) != 'aborted' ? 'No' : 'YES')+"\n"
                                            ;
            });
        }else{
            invoicedJobs.push(
                <tr key='no-records'><td colSpan="26" className='text-center'>No Records</td></tr>
            );
        }
        
        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Non Invoiced Jobs Report</h2>
                    <br/>
                </div>
                
                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Start Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select End Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Customer</h5></label><br/>
                            <div>
                                <StatefulMultiSelect
                                    options={this.state.customers}
                                    selected={selectedCustomers}
                                    onSelectedChanged={this.handleCustomerSelection}
                                        overrideStrings={{
                                            selectSomeItems: "Select Customers...",
                                            allItemsAreSelected: "All Customers are Selected",
                                            selectAll: "Select All",
                                            search: "Search Customer",
                                        }}
                                    />
                            </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={(e) => this.handleInvoicedJobsReportGeneration(e)}>
                                   <i className="fa fa-save"></i> Generate Non Invoiced Jobs Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin"
                                    onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataInvoiced);
                                  }}>
                                <i className="fa fa-download"></i> Download Non Invoiced Report
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3"><label className="alert alert-primary"><b>{this.state.InvoicedJobsReportData.length} jobs found..</b></label></div>             
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead className="sticky-top-without-zindex bg-light">
                                    <tr>
                                        <th>Job Ref</th>
                                        <th>Reg/VIN</th>
                                        <th>Customer</th>
                                        <th>Driver</th>
                                        <th>Driver price</th>
                                        <th>Aborted Job</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.isLoading ?
                                (<tr><td colSpan="26"><span className="add-loading-text">
                                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                    invoicedJobs
                                }
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-non_invoiced_jobs_report')) {
    ReactDOM.render(
        <NonInvoicedJobsReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-non_invoiced_jobs_report')
    );
}
